
<div
  class="top-right-action-buttons"
  :class="{ 'regenerate-btn-styles': showRegenerate }"
>
  <cvt-button
    v-if="showDuplicate"
    class="ab-duplicate-btn"
    color="light"
    size="sm"
    :outlined="false"
    :icon="iconConfig.propertiesSidebar.copy || 'copy'"
    @click="$emit('duplicate')"
  />

  <cvt-button
    v-if="showRegenerate"
    class="ab-regenerate-btn"
    color="light"
    size="sm"
    :outlined="false"
    :icon="'refresh'"
    @click="
      () => {
        $emit('regenerate')
      }
    "
  />

  <cvt-button
    v-if="showDelete"
    class="ab-delete-btn"
    color="light"
    size="sm"
    :outlined="false"
    :icon="iconConfig.propertiesSidebar.remove || 'trash'"
    @click="$emit('remove')"
  />
</div>
